import quickFetch from 'quick-fetch';
import Raven from 'raven-js';
import emptyFunction from 'react-utils/emptyFunction';
// @ts-ignore untyped import
import { createAction } from 'flux-actions';
import { createRequestAction, createRequestStatusMeta } from 'MeetingsBase/utils/actions';
import getIn from 'transmute/getIn';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
import { Map as ImmutableMap } from 'immutable';
import { showUserMessage } from './UIActions';
import { fetchPublicAvailabilityInfoFallback as fetchPublicAvailabilityInfoFallbackRequest, fetchMeetingsUser as fetchMeetingsUserRequest, fetchMeetingsUserWithParams, fetchCompanyName as fetchCompanyNameRequest, createMeeting as createMeetingRequest, meetingBookFailure as meetingBookFailureRequest, cancelMeeting as cancelMeetingRequest, fetchEventDetails as fetchEventDetailsRequest, rescheduleMeeting as rescheduleMeetingRequest } from 'MeetingsLib/api/bookingAPI';
import { fetchV3PublicAvailabilityInfo as fetchPublicAvailabilityInfoRequest } from 'MeetingsLib/api/bookingAPIV3';
import userInfo from 'hub-http/userInfo';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import { maybeRedirectToHubSpotDomain, redirectToMigratedPortal } from 'MeetingsLib/utils/utils';
import { setFormState } from './FormActions';
import { shouldFetchAvailability, getUserProfile as getUserProfileSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getFormFields, getInitialFormState } from 'MeetingsLib/selectors/FormFieldValidationSelector';
import { canSubmitInitialPropertyForm as canSubmitInitialPropertyFormSelector } from 'MeetingsLib/selectors/AutoSubmitSelector';
import { getFetchAvailabilityQueryParams, getCreateMeetingQueryParams, getCreateMeetingBodyData, getEmbedded, buildMeetingRescheduleRequestBody } from 'MeetingsLib/selectors/RESTParamSelectors';
import { isSubmittingMeeting } from 'MeetingsLib/selectors/RequestStatusSelectors';
import { getDisablePrefill } from 'MeetingsLib/selectors/PrefillSelectors';
import { shouldAllowTroubleshootMode } from 'MeetingsLib/selectors/TroubleshootingSelectors';
import { getPaymentSuccessfulSelector } from 'MeetingsLib/selectors/PaymentStatusSelectors';
import PublicMeetingsUser from 'MeetingsBase/models/PublicMeetingsUser';
import PublicAvailabilityInfo from 'MeetingsBase/models/PublicAvailabilityInfo';
import FormState from 'MeetingsLib/models/FormState';
import TimeRange from 'MeetingsBase/models/TimeRange';
import UserProfile from 'MeetingsBase/models/UserProfile';
import { createBranding } from 'MeetingsBase/models/Branding';
import { BOOKING_TIME_CONFLICT, MEETING_TEMPORARILY_UNAVAILABLE } from 'MeetingsLib/constants/errors';
import { LINK_TYPES, MEETING_TYPES } from 'MeetingsBase/constants/enums';
import { STATUS } from 'MeetingsLib/constants/status';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import LinkAvailability from 'MeetingsBase/models/LinkAvailability';
import { sanitizeFormFields, sanitizeString } from 'MeetingsLib/utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
export const logMeetingCreation = createAction(ActionTypes.LOG_MEETING_CREATE);
export const fetchPublicAvailabilityInfoAction = createRequestAction(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_STARTED);
export const fetchPublicAvailabilityInfoSucceededAction = createRequestAction(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
res => {
  const bookInfo = PublicAvailabilityInfo.from(res);
  const postResponse = {
    customFormFields: FormState.customFieldsFromBookInfo(res),
    bookInfo,
    meetingsUser: PublicMeetingsUser.fromBookInfo(bookInfo),
    branding: createBranding(res.brandingMetadata)
  };
  const hasMeetingsUser = !!postResponse.meetingsUser;
  Raven.setExtraContext({
    bookInfoHasMeetingsUser: hasMeetingsUser,
    calendarProvider: hasMeetingsUser && postResponse.meetingsUser.calendarProvider
  });
  return postResponse;
});
export const fetchPublicAvailabilityInfoSucceeded = (response, changeLocale) => (dispatch, getState) => {
  const dispatchSuccess = () => {
    let state = getState();
    const disablePrefill = getDisablePrefill(state);
    if (disablePrefill) {
      response.formPrefills = {};
      response.tokenPrefills = {};
    }
    dispatch(fetchPublicAvailabilityInfoSucceededAction(response));
    // get new state after dispatch above; see https://git.hubteam.com/HubSpot/MeetingsUI/pull/2367 for context
    state = getState();
    const initialFormState = getInitialFormState(state);
    // Will not be true if async email validation is in progress or the results show that the initial email is invalid
    const shouldSetFormState = canSubmitInitialPropertyFormSelector(state);
    if (initialFormState && shouldSetFormState) {
      // @ts-ignore fix type
      void dispatch(setFormState(initialFormState));
    }
  };
  const locale = response.customParams.locale;
  const language = response.customParams.language;
  if (locale) {
    if (changeLocale) {
      changeLocale(locale, language).then(() => {
        const rtlLocales = ['ar-eg', 'he-il'];
        if (rtlLocales.includes(locale)) document.documentElement.dir = 'rtl';
        dispatchSuccess();
      }).catch(emptyFunction);
    } else {
      // legacy I18n locale change API - to be replaced by I18n Providers
      try {
        var _I18n$changeLocale;
        // @ts-ignore fix type
        I18n.langEnabled = language !== 'en';
        // @ts-ignore fix type
        (_I18n$changeLocale = I18n.changeLocale(locale)) === null || _I18n$changeLocale === void 0 || _I18n$changeLocale.then(dispatchSuccess);
      } catch (err) {
        console.log('error changing legacy locale:', err);
      } finally {
        dispatchSuccess();
      }
    }
  } else {
    dispatchSuccess();
  }
};
export const fetchPublicAvailabilityInfoFailed = createRequestAction(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_FAILED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
error => ({
  error
}));
export const fetchPublicAvailabilityInfoForOwnerAction = createRequestAction(ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_STARTED);
export const fetchPublicAvailabilityInfoForOwnerSucceeded = createRequestAction(ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
response => {
  const postResponse = {
    customFormFields: FormState.customFieldsFromBookInfo(response),
    bookInfo: PublicAvailabilityInfo.from(response)
  };
  return postResponse;
});
export const fetchPublicAvailabilityInfoForOwnerFailed = createRequestAction(ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_FAILED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
error => ({
  error
}));
export const updateLinkAvailability = (linkAvailability, currentMonthOffset) => {
  return {
    type: ActionTypes.UPDATE_LINK_AVAILABILITY,
    payload: {
      linkAvailability,
      currentMonthOffset
    }
  };
};
export const updateUserBusyTimes = allUsersBusyTimes => {
  return {
    type: ActionTypes.UPDATE_USER_BUSY_TIMES,
    payload: {
      allUsersBusyTimes
    }
  };
};
const fetchWithEarlyRequestHook = (fallbackFetch, requestName) => {
  const earlyRequest = quickFetch.getRequestStateByName(requestName);
  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished((...args) => {
        const mark = `${requestName}-finished`;
        try {
          if (window.performance && window.performance.mark && window.performance.measure) {
            window.performance.mark(mark);
            window.performance.measure(`${requestName}-after-mount`, 'create-booking-component', mark);
          }
          resolve(...args);
          quickFetch.removeEarlyRequest(requestName);
        } catch (error) {
          Raven.captureException(error, {
            extra: {
              message: 'Exception at whenFinished earlyRequest'
            }
          });
        }
      });
      earlyRequest.onError((xhr, message) => {
        Raven.captureException(new Error(message), {
          extra: {
            message: 'Exception at onError earlyRequest'
          }
        });
        fallbackFetch().then(resolve).catch(reject);
        quickFetch.removeEarlyRequest(requestName);
      });
    });
  }
  return fallbackFetch();
};
export const fetchMeetingsUserStarted = createRequestAction(ActionTypes.MEETINGS_USER_FETCH_STARTED);
export const fetchMeetingsUserSucceeded = createRequestAction(ActionTypes.MEETINGS_USER_FETCH_SUCCEEDED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
response => {
  const meetingsUser = PublicMeetingsUser.from(response);
  Raven.setExtraContext({
    calendarProvider: meetingsUser.calendarProvider
  });
  return {
    meetingsUser
  };
});
export const fetchMeetingsUserFailed = createRequestAction(ActionTypes.MEETINGS_USER_FETCH_FAILED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
error => ({
  error
}));
function fetchMeetingsUser() {
  return (dispatch, getState, httpClient) => {
    const slug = getState().userSlug;
    dispatch(fetchMeetingsUserStarted());
    // @ts-ignore fix type
    return fetchMeetingsUserRequest(httpClient, slug, true).then(response => {
      dispatch(fetchMeetingsUserSucceeded(response));
    }, response => {
      dispatch(fetchMeetingsUserFailed(response));
    });
  };
}
export function fetchMeetingsUserForContactOwnerPrioritization(email) {
  return (dispatch, getState, httpClient) => {
    const queryParams = getFetchAvailabilityQueryParams({
      email
    })(getState());
    dispatch(fetchMeetingsUserStarted());
    return fetchMeetingsUserWithParams(httpClient, queryParams).then(response => {
      dispatch(fetchMeetingsUserSucceeded(response));
    }, response => {
      dispatch(fetchMeetingsUserFailed(response));
    });
  };
}
function fetchPortalAuth(portalId) {
  return (dispatch, getState) => {
    const state = getState();
    const shouldAllowTroubleshoot = shouldAllowTroubleshootMode(state);
    const embedded = getEmbedded(state);
    if (shouldAllowTroubleshoot && !embedded) {
      userInfo({
        // @ts-ignore fix type
        portalId,
        ignoreRedirect: true,
        // @ts-ignore fix type
        hubletOverride: window.hubspot.meetingsHubletOverride
      }).then(res => {
        dispatch({
          type: ActionTypes.PORTAL_AUTH_SUCCEEDED,
          payload: res
        });
      }).catch(() => {});
    }
  };
}
const createPublicAvailabilityFetcher = (dispatch, getState, params, useRetryClient = false) => {
  const state = getState();
  const queryParams = getFetchAvailabilityQueryParams(params)(state);
  /*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
  return () => fetchPublicAvailabilityInfoRequest(queryParams, useRetryClient);
};
const getResponseText = response => {
  if (response.responseText) {
    let parsed = null;
    try {
      parsed = JSON.parse(response.responseText);
    } catch (e) {
      return parsed;
    }
    return parsed;
  }
  return null;
};
export function fetchPublicAvailabilityInfoFallback(params, changeLocale) {
  return (dispatch, getState, httpClient) => {
    dispatch(fetchPublicAvailabilityInfoAction());
    const state = getState();
    const queryParams = getFetchAvailabilityQueryParams(params)(state);
    return fetchPublicAvailabilityInfoFallbackRequest(httpClient, queryParams).then(response => {
      // @ts-ignore fix type
      const bookInfo = PublicAvailabilityInfo.from(response);
      const meetingsUser = PublicMeetingsUser.fromBookInfo(bookInfo);
      const portalId = bookInfo.portalId;
      if (new URLSearchParams(window.location.search).get('troubleshoot') === 'true') {
        // @ts-ignore fix type
        dispatch(fetchPortalAuth(portalId));
      }
      if (!meetingsUser) {
        return fetchMeetingsUser()(dispatch, getState, httpClient).then(() => {
          dispatch(fetchPublicAvailabilityInfoSucceeded(response, changeLocale));
          return bookInfo;
        });
      } else {
        dispatch(fetchPublicAvailabilityInfoSucceeded(response, changeLocale));
        return bookInfo;
      }
    }, error => {
      if (error && error.status === STATUS.HUBLET_REDIRECT) {
        const errorObject = getResponseText(error);
        if (errorObject && errorObject.baseUrl && errorObject.slug) {
          // fail silently and redirect
          return redirectToMigratedPortal(errorObject.baseUrl, errorObject.slug, {
            searchParams: window.location.search
          });
        }
        // Only log to Sentry if we can't redirect due to missing data
        Raven.captureMessage('Hublet redirect failed - missing baseUrl or slug', {
          level: 'error',
          extra: {
            message: error.message,
            status: error.status,
            errorObject,
            responseText: error.responseText
          }
        });
        return dispatch(fetchPublicAvailabilityInfoFailed(error));
      }
      Raven.captureMessage('Failed to fetch from booking fallback endpoint', {
        level: 'error',
        extra: {
          message: error.message,
          status: error.status
        }
      });
      return dispatch(fetchPublicAvailabilityInfoFailed(error));
    });
  };
}
export function fetchPublicAvailabilityInfo(params, changeLocale, useRetryClient = false) {
  return (dispatch, getState, httpClient) => {
    dispatch(fetchPublicAvailabilityInfoAction());
    const fetch = createPublicAvailabilityFetcher(dispatch, getState, params, useRetryClient);
    /**
     *  use fetch in retry because early requester will return the cached response
     */
    const fetchPromise = useRetryClient ? fetch() : fetchWithEarlyRequestHook(fetch, 'book-info');
    return fetchPromise.then(response => {
      // @ts-ignore fix type
      const bookInfo = PublicAvailabilityInfo.from(response);
      const meetingsUser = PublicMeetingsUser.fromBookInfo(bookInfo);
      const portalId = bookInfo.portalId;
      if (new URLSearchParams(window.location.search).get('troubleshoot') === 'true') {
        // @ts-ignore fix type
        dispatch(fetchPortalAuth(portalId));
      }
      if (!meetingsUser) {
        return fetchMeetingsUser()(dispatch, getState, httpClient).then(() => {
          dispatch(fetchPublicAvailabilityInfoSucceeded(response, changeLocale));
          return bookInfo;
        });
      } else {
        dispatch(fetchPublicAvailabilityInfoSucceeded(response, changeLocale));
        return bookInfo;
      }
    }, error => {
      let isBookingFailureInjection = false;
      try {
        isBookingFailureInjection = window.localStorage.getItem('BOOKING_FAILURE_INJECTION') === 'true';
      } catch (err) {
        console.log(err);
      }
      const shouldRetryOrFallbackToFailureEndpoint = error.status === 0 || error.status >= 500 || isBookingFailureInjection;
      if (shouldRetryOrFallbackToFailureEndpoint && !useRetryClient) {
        useRetryClient = true;
        if (error.status !== 0) {
          Raven.captureMessage('Retrying availability failure', {
            level: 'error',
            extra: {
              json: error.responseJSON,
              message: error.message,
              status: error.status
            }
          });
        }
        return dispatch(fetchPublicAvailabilityInfo(params, changeLocale, useRetryClient));
      }
      if (error && error.status === STATUS.HUBLET_REDIRECT) {
        const errorObject = getResponseText(error);
        if (errorObject && errorObject.baseUrl && errorObject.slug) {
          // fail silently and redirect
          return redirectToMigratedPortal(errorObject.baseUrl, errorObject.slug, {
            searchParams: window.location.search
          });
        }
        // Only log to Sentry if we can't redirect due to missing data
        Raven.captureMessage('Hublet redirect failed - missing baseUrl or slug', {
          level: 'error',
          extra: {
            message: error.message,
            status: error.status,
            errorObject,
            responseText: error.responseText
          }
        });
        dispatch(fetchPublicAvailabilityInfoFailed(error));
        throw error;
      }

      // redirect users who try to hit meeting links on
      // www.hubspot.com when they are not hosted there
      if (error && error.status === STATUS.NOT_FOUND) {
        dispatch(fetchPublicAvailabilityInfoFailed(error));
        return maybeRedirectToHubSpotDomain(window.location.host);
      } else {
        if (shouldRetryOrFallbackToFailureEndpoint) {
          if (error.status !== 0) {
            Raven.captureMessage(error, {
              level: 'error',
              extra: {
                internalMessage: 'Failed to fetch book-info from either quick-fetch or hub-http',
                json: error.responseJSON,
                message: error.message,
                status: error.status
              }
            });
          }
          return dispatch(fetchPublicAvailabilityInfoFallback(params, changeLocale));
        }
        dispatch(fetchPublicAvailabilityInfoFailed(error));
      }
      throw error;
    });
  };
}
export function fetchPublicAvailabilityInfoForOwner(params) {
  return (dispatch, getState) => {
    dispatch(fetchPublicAvailabilityInfoForOwnerAction());
    const fetch = createPublicAvailabilityFetcher(dispatch, getState, params);
    return fetch().then(response => {
      dispatch(fetchPublicAvailabilityInfoForOwnerSucceeded(response));
      // @ts-ignore fix type
      return PublicAvailabilityInfo.from(response);
    }, error => {
      dispatch(fetchPublicAvailabilityInfoForOwnerFailed(error));
      return Promise.reject(error);
    });
  };
}
export const fetchCompanyNameAction = createRequestAction(ActionTypes.COMPANY_NAME_FETCH_STARTED);
export const fetchCompanyNameSucceeded = createRequestAction(ActionTypes.COMPANY_NAME_FETCH_SUCCEEDED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
response => response.companyName);
export const fetchCompanyNameFailed = createRequestAction(ActionTypes.COMPANY_NAME_FETCH_FAILED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
error => ({
  error
}));
export function fetchCompanyName() {
  return (dispatch, getState, httpClient) => {
    dispatch(fetchCompanyNameAction());
    // @ts-ignore fix type
    const slug = encodeURIComponent(getState().userSlug);
    return fetchCompanyNameRequest(httpClient, slug).then(response => {
      dispatch(fetchCompanyNameSucceeded(response));
      return response;
    }, error => {
      dispatch(fetchCompanyNameFailed(error));
    });
  };
}
export function getAvailability(changeLocale) {
  return (dispatch, getState) => {
    if (shouldFetchAvailability(getState())) {
      const params = {
        includeDeleted: 'true'
      };
      // @ts-ignore fix type
      dispatch(fetchPublicAvailabilityInfo(params, changeLocale)).then(bookInfo => {
        if (bookInfo && bookInfo.linkType === LINK_TYPES.get(MEETING_TYPES.ROUND_ROBIN) && !getIn(['customParams', 'displayInfo', 'headline'], bookInfo)) {
          // @ts-ignore fix type
          void dispatch(fetchCompanyName());
        }
      }).catch(error => {
        if (error && error.status === 404) {
          // @ts-ignore fix type
          void dispatch(fetchMeetingsUser());
        }
      });
    }
    return Promise.resolve();
  };
}
export const createMeetingAction = createRequestAction(ActionTypes.MEETING_CREATE_STARTED);
export const createMeetingReset = createAction(ActionTypes.MEETING_CREATE_RESET, null, () => createRequestStatusMeta(ActionTypes.MEETING_CREATE_UNINITIALIZED));
export const createMeetingSucceeded = createRequestAction(ActionTypes.MEETING_CREATE_SUCCEEDED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
response => {
  // @ts-ignore improper api usage
  const postResponse = new ImmutableMap({
    timerange: TimeRange.from({
      start: response.start,
      end: response.end
    }),
    organizer: UserProfile.from(response.organizer),
    bookedOffline: response.isOffline,
    contact: UserProfile.from(response.contact)
  });
  return postResponse;
});
export const createMeetingFailed = createRequestAction(ActionTypes.MEETING_CREATE_FAILED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
error => ({
  error
}));
const bookingTimeConflict = createAction(ActionTypes.BOOKING_TIME_CONFLICT, linkAvailability => ({
  linkAvailability: LinkAvailability.from(linkAvailability)
}), () => createRequestStatusMeta(ActionTypes.MEETING_CREATE_UNINITIALIZED));
export function createMeeting(event, useRetryClient = false) {
  return (dispatch, getState, httpClient) => {
    dispatch(createMeetingAction());
    const state = getState();
    const formFields = getFormFields(state);
    const formFieldsMetadata = formFields && formFields.map(formField => formField.toJSON()) || [];
    const initialData = ImmutableMap(getCreateMeetingBodyData(event)(state));
    const queryParams = getCreateMeetingQueryParams(state);
    const sanitizeFirstName = sanitizeString(initialData.get('firstName'));
    const sanitizeLastName = sanitizeString(initialData.get('lastName'));
    const sanitizedFormFields = sanitizeFormFields(initialData.get('formFields'), formFieldsMetadata);
    const data = initialData.set('firstName', sanitizeFirstName).set('lastName', sanitizeLastName).set('formFields', sanitizedFormFields);
    return createMeetingRequest(httpClient, queryParams, data, useRetryClient).then(response => {
      dispatch(createMeetingSucceeded(response));
      return response;
    }, error => {
      let isBookingFailureInjection = false;
      try {
        isBookingFailureInjection = window.localStorage.getItem('BOOKING_FAILURE_INJECTION') === 'true';
      } catch (err) {
        console.log(err);
      }
      const shouldRetryOrFallbackToFailureEndpoint = error.status >= 500 || isBookingFailureInjection;
      if (!useRetryClient && shouldRetryOrFallbackToFailureEndpoint) {
        useRetryClient = true;
        Raven.captureMessage('Retrying createMeeting failure', {
          level: 'error',
          extra: {
            json: error.responseJSON,
            message: error.message,
            status: error.status
          }
        });
        return dispatch(createMeeting(event, useRetryClient));
      }
      if (error.status === 400 && error.responseJSON && error.responseJSON.errorType === 'TIME_SLOT_NOT_AVAILABLE') {
        dispatch(bookingTimeConflict(error.responseJSON.linkAvailability));
        track('Meetings', 'Scheduling Interaction', {
          action: 'viewed-meeting-conflict-error',
          project: 'MeetingsLib'
        });
        throw Error(BOOKING_TIME_CONFLICT);
      }
      if (error.status === 404 && error.responseJSON && error.responseJSON.subCategory === MEETING_TEMPORARILY_UNAVAILABLE) {
        throw Error(MEETING_TEMPORARILY_UNAVAILABLE);
      }
      dispatch(createMeetingFailed(error));
      Raven.captureMessage('Failed to write to meeting endpoint', {
        level: 'error',
        extra: {
          json: error.responseJSON,
          message: error.message,
          status: error.status
        }
      });
      if (shouldRetryOrFallbackToFailureEndpoint) {
        // TODO: Better type support
        const payload = Object.assign({}, data.toJS());
        meetingBookFailureRequest(httpClient, queryParams, payload).catch(err => {
          Raven.captureMessage('Failed to write to meeting failure endpoint', {
            level: 'error',
            extra: {
              message: err.responseText,
              json: err.responseJSON
            }
          });
        });
      }
      throw error;
    });
  };
}
export const trackPaidMeetingBookedSuccessfully = () => ({
  type: ActionTypes.PAID_MEETING_BOOKED_SUCCESSFULLY
});
export const trackPaidMeetingBookedTimeUnavailable = () => ({
  type: ActionTypes.PAID_MEETING_BOOKING_TIME_UNAVAILABLE
});
export const trackPaidMeetingBookingFailure = () => ({
  type: ActionTypes.PAID_MEETING_BOOKING_FAILURE
});
export const meetingRescheduleStartedAction = createRequestAction(ActionTypes.MEETING_RESCHEDULE_STARTED);
export const meetingRescheduleSucceededAction = createRequestAction(ActionTypes.MEETING_RESCHEDULE_SUCCEEDED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
requestBody => {
  // @ts-ignore improper api usage
  const postResponse = new ImmutableMap({
    timerange: TimeRange.from({
      start: requestBody.startTime,
      end: requestBody.endTime
    }),
    bookedOffline: requestBody.isOffline
  });
  return postResponse;
});
export const meetingRescheduleFailedAction = createRequestAction(ActionTypes.MEETING_RESCHEDULE_FAILED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
error => ({
  error
}));
const generateRescheduleSuccessForTemporarilyUnavailableResponse = event => {
  return {
    // @ts-ignore fix type
    startTime: event.startTime,
    // @ts-ignore fix type
    endTime: event.endTime,
    isOffline: true
  };
};
export const rescheduleMeeting = event => (dispatch, getState, httpClient) => {
  const state = getState();
  dispatch(meetingRescheduleStartedAction());
  const meetingRescheduleRequestBody = buildMeetingRescheduleRequestBody(event)(state);
  rescheduleMeetingRequest(httpClient, meetingRescheduleRequestBody).then(() => {
    dispatch(meetingRescheduleSucceededAction(meetingRescheduleRequestBody));
  }).catch(error => {
    if (error.status === 404 && error.responseJSON && error.responseJSON.subCategory === MEETING_TEMPORARILY_UNAVAILABLE) {
      const generatedEventResponse = generateRescheduleSuccessForTemporarilyUnavailableResponse( /*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
      meetingRescheduleRequestBody);
      dispatch(meetingRescheduleSucceededAction(generatedEventResponse));
    } else {
      // Trigger error component to allow users to fallback to booking a new meeting
      dispatch(meetingRescheduleFailedAction(error));
    }
  });
};
const generateSuccessForTemporarilyUnvailableResponse = event => {
  return {
    start: event.dateTime,
    // @ts-ignore fix type
    end: event.dateTime + event.duration,
    organizer: null,
    isOffline: true
  };
};
export const bookMeeting = () => (dispatch, getState) => {
  const state = getState();
  const {
    isSalesStarter,
    calendarProvider,
    bookInfo: {
      linkType
    },
    bookingLifecycle: {
      event
    },
    isRescheduling
  } = state;
  /*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
  const {
    email
  } = getUserProfileSelector(state);
  const submittingMeeting = isSubmittingMeeting(state);
  const isPaidMeeting = getPaymentSuccessfulSelector(state);
  if (submittingMeeting) {
    return null;
  }
  if (isRescheduling) {
    // @ts-ignore fix type
    return dispatch(rescheduleMeeting(event));
  }
  // @ts-ignore fix type
  return dispatch(createMeeting(event)).then(() => {
    dispatch(logMeetingCreation({
      integration: calendarProvider,
      linkType,
      isSalesStarter
    }));
    if (isPaidMeeting) {
      dispatch(trackPaidMeetingBookedSuccessfully());
    }
  }, error => {
    if (error.message.includes(BOOKING_TIME_CONFLICT)) {
      dispatch(showUserMessage({
        type: 'info',
        content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "errorMessages.bookedFromUnder"
        })
      }));
      if (isPaidMeeting) {
        dispatch(trackPaidMeetingBookedTimeUnavailable());
      }
    } else if (error.message === MEETING_TEMPORARILY_UNAVAILABLE) {
      const generatedEventResponse = generateSuccessForTemporarilyUnvailableResponse(event);
      dispatch(createMeetingSucceeded(generatedEventResponse));
    } else {
      dispatch(showUserMessage({
        type: 'danger',
        content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "errorMessages.tryAgain",
          options: {
            email
          }
        })
      }));
      if (isPaidMeeting) {
        dispatch(trackPaidMeetingBookingFailure());
      }
    }
  });
};
export const fetchEventDetailsSucceededAction = createRequestAction(ActionTypes.FETCH_EVENT_DETAILS_SUCCEEDED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
res => res);
export const fetchEventDetailsFailedAction = createRequestAction(ActionTypes.FETCH_EVENT_DETAILS_FAILED);
export const fetchEventDetails = (slug, meetingChangeId) => (dispatch, getState, httpClient) => {
  return fetchEventDetailsRequest(httpClient, slug, meetingChangeId).then(eventDetails => {
    dispatch(fetchEventDetailsSucceededAction(eventDetails));
    return eventDetails;
  }, err => {
    dispatch(fetchEventDetailsFailedAction(err));
    return err;
  });
};
export const cancelMeetingAction = createRequestAction(ActionTypes.MEETING_CANCEL_STARTED);
export const cancelMeetingSucceededAction = createRequestAction(ActionTypes.MEETING_CANCEL_SUCCEEDED);
export const cancelMeetingFailedAction = createRequestAction(ActionTypes.MEETING_CANCEL_FAILED,
// @ts-ignore TS2345: TypeScript 5.7.3 stricter function signature checking
error => ({
  error
}));
export const cancelMeeting = (slug, meetingChangeId) => (dispatch, getState, httpClient) => {
  dispatch(cancelMeetingAction());
  return cancelMeetingRequest(httpClient, slug, meetingChangeId).then(() => {
    dispatch(cancelMeetingSucceededAction());
  }, err => {
    let errorMessage = '';
    if (err.status === 404 && err.responseJSON && err.responseJSON.subCategory === MEETING_TEMPORARILY_UNAVAILABLE) {
      errorMessage = err.responseJSON.subCategory;
    } else {
      const rawResponseJSON = Object.entries(err).filter(entry => entry[0] === 'responseJSON')[0];
      // @ts-ignore fix type
      errorMessage = rawResponseJSON ? rawResponseJSON[1].message : '';
    }
    dispatch(cancelMeetingFailedAction(errorMessage));
  });
};